// Where an account connection comes back to. Mirrors the server's
// oauthReturnUrl (server/src/utils/oauthConnectStart.ts), which redirects the
// OAuth callback; the LinkedIn page picker finishes client-side and uses this.

export type OAuthReturnTarget = {
  returnPath?: "/analytics" | "/onboarding" | "/create-post";
  returnDraftId?: string;
  returnIntent?: "publish-now" | "schedule";
};

export function parseOAuthReturnTarget(value: unknown): OAuthReturnTarget {
  const source = (value || {}) as Record<string, unknown>;
  const path = source.returnPath;
  if (path === "/analytics" || path === "/onboarding") return { returnPath: path };
  const draftId = source.returnDraftId;
  if (path === "/create-post" && typeof draftId === "string" && /^[A-Za-z0-9_-]{1,128}$/.test(draftId)) {
    const intent = source.returnIntent;
    return {
      returnPath: "/create-post",
      returnDraftId: draftId,
      ...(intent === "publish-now" || intent === "schedule" ? { returnIntent: intent } : {}),
    };
  }
  return {};
}

/** The in-app path to return to; pass a status to report the outcome. */
export function oauthReturnPath(
  target: OAuthReturnTarget,
  status?: "success" | "error",
  detail?: string
): string {
  const params = new URLSearchParams();
  let path = "/settings";
  if (target.returnPath === "/analytics" || target.returnPath === "/onboarding") {
    path = target.returnPath;
  } else if (target.returnPath === "/create-post" && target.returnDraftId) {
    path = "/create-post";
    params.set("draftId", target.returnDraftId);
    if (target.returnIntent) params.set("intent", target.returnIntent);
  }
  if (status) {
    params.set("status", status);
    if (detail) params.set(status === "error" ? "error" : "platform", detail);
  }
  const query = params.toString();
  return query ? `${path}?${query}` : path;
}
